<template>
  <div>
    <div class="page-wrapper">
      <div class="page-content-wrapper">
        <div class="col-12 shadow-btm row">
          <div class="col-lg-6 col-sm-6 my-auto">
            <h4 class="mb-0 lg-bld">Manage Email Group</h4>
          </div>
          <div class="col-6 text-right" v-show="accessObject?.is_add == 1">
            <a
              style="padding-left: 20px; padding-right: 20px; cursor: pointer"
              v-on:click="$router.push('/add-edit-emailgroup')"
              class="add-btn">
              Add
            </a>
          </div>
        </div>
        <div class="page-content">
          <div class="card-body py-0 px-0">
            <div class="row">
              <div class="col-lg-6 col-sm-6 form-group row">
                <div class="has-search ml-3">
                  <i class="fa fa-search" style="position: absolute; margin: 10px" aria-hidden="true"></i>
                  <input
                    type="text"
                    class="form-control"
                    v-on:keyup.enter="getList(0)"
                    placeholder="Search"
                    v-model="searchObj.keyword" />
                </div>
                <a class="search-btn btn-style cursor-pointer ml-3" v-on:click="getList(0)">Search</a>
                <a class="search-btn btn-style cursor-pointer" v-on:click="resetFilter">Reset</a>
              </div>
            </div>
            <div class="card border mb-0 radius-15">
              <div class="card-body p-0 pb-4">
                <div class="table-responsive">
                  <div class="dataTables_wrapper dt-bootstrap4">
                    <table
                      class="table table-striped table-bordered dataTable"
                      style="width: 100%"
                      role="grid"
                      aria-describedby="example_info">
                      <thead>
                        <tr role="row">
                          <th class="sorting" id="id-name" v-on:click="sorting('id', 'id-name')">Sr No</th>
                          <th class="sorting" id="id-name" v-on:click="sorting('name', 'id-name')">Group Name</th>
                          <th class="sorting" id="id-email" v-on:click="sorting('status', 'id-email')">Status</th>
                          <th v-if="accessObject?.is_edit == 1 || accessObject?.is_delete == 1">Action</th>
                        </tr>
                      </thead>
                      <tbody v-show="!loader">
                        <tr v-for="(data, index) in list" :key="index">
                          <td>
                            {{ ($refs.listPagination.currentPage - 1) * $refs.listPagination.itemsPerPage + index + 1 }}
                          </td>
                          <td>{{ data.name }}</td>
                          <td>
                            <a v-show="data.status == 'ACTIVE'" id="status-btn" class="fill-btn btn-style">ACTIVE</a>
                            <a v-show="data.status == 'INACTIVE'" id="status-btn" class="reject-btn btn-style">
                              INACTIVE
                            </a>
                          </td>
                          <td v-if="accessObject?.is_edit == 1 || accessObject?.is_delete == 1">
                            <!-- Toggle Status Button -->
                            <a
                              v-if="accessObject?.is_publish == 1"
                              class="btn-style cursor-pointer"
                              :class="data.status == 'ACTIVE' ? 'reject-btn' : 'fill-btn'"
                              @click="toggleStatus(data.id)">
                              {{ data.status == "ACTIVE" ? "Inactive" : "Active" }}
                            </a>

                            <a
                              v-if="accessObject?.is_edit == 1"
                              class="edit-btn btn-style cursor-pointer"
                              @click="$router.push('/add-edit-emailgroup/' + data.id)">
                              Edit
                            </a>
                            <a
                              v-if="accessObject?.is_delete == 1"
                              class="delete-btn btn-style cursor-pointer"
                              @click="showDeletePopup(data)">
                              Delete
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="row mx-0 mb-4">
                  <div class="col-lg-12 mt-5 text-center">
                    <div class="page-bottom-pagination text-right">
                      <Pagination
                        @page-change="pageChange"
                        @items-per-page-change="itemsPerPageChange"
                        ref="listPagination" />
                    </div>
                  </div>
                </div>
                <ErrorComponent @retry="getList(0)" ref="errorComponent" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <DeleteModal @remove="deleteRecord($event)" @get-list="getList(0)" ref="deleteItem" />
  </div>
</template>
<script>
import ErrorComponent from "@/components/ErrorComponent";
import DeleteModal from "@/components/DeleteModal";
import Pagination from "@/components/Pagination";

export default {
  name: "Package Group",
  components: {
    ErrorComponent,
    DeleteModal,
    Pagination,
  },
  data() {
    return {
      accessObject: this.$helperService.getAccessLevel("Manage Email Group And User"),
      loader: true,
      searchObj: {},
      offset: -1,
      list: [],
    };
  },
  mounted() {
    this.getList(0);
  },
  methods: {
    pageChange(offset) {
      this.getList(offset - 1);
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
      this.getList(0);
    },
    getList(page, orderBy, sortBy) {
      this.$refs.errorComponent.updateListLoader(true);
      this.list = [];
      this.searchObj.offset = page;
      if (orderBy) {
        this.searchObj.order_by = orderBy;
      }
      if (sortBy) {
        this.searchObj.sort_by = sortBy;
      }
      this.$api
        .getAPI({
          _action: "/email_group/list",
          _body: this.searchObj,
        })
        .then((res) => {
          this.loader = false;
          this.list = res.list;
          this.offset = res.next_offset;
          this.accessObject = this.$helperService.getAccessLevel("Manage Email Group And User");
          if (page == 0) {
            if (this.$refs.listPagination) {
              if (res.count != null && res.count > 0) {
                this.$refs.listPagination.setTotalCount(res.count);
              } else {
                this.$refs.listPagination.setTotalCount(0);
              }
            }
          }
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(res, "email group list empty");
            this.$refs.errorComponent.updateListLoader(false);
          }
        })
        .catch(() => {
          this.loader = false;
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(0, undefined, "");
            this.$refs.errorComponent.updateListLoader(false);
          }
        });
    },
    sorting(sortBy, id) {
      var obj = this.$helperService.sorting(sortBy, id);
      this.getList(0, obj.order_by, obj.sort_by);
    },
    resetFilter() {
      this.searchObj.keyword = "";
      this.getList(0);
    },
    toggleStatus(id) {
      this.sendLoading = true;
      this.$api
        .postAPI({
          _action: "/email_group/update_status/" + id, // your backend API
        })
        .then((res) => {
          this.sendLoading = false;
          this.$notify({
            type: "success",
            text: res.message,
          });

          // refresh list
          this.getList(0);

          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(res, " ");
          }
        })
        .catch(() => {
          this.sendLoading = false;
        });
    },
    showDeletePopup(data) {
      this.$refs.deleteItem.showModal("Delete Email Group", "Are you sure you want to delete " + data.name, data);
    },
    deleteRecord(dataObj) {
      var detail = new Proxy(dataObj, {});
      this.$refs.deleteItem.deleteRecord("/email_group/delete/" + detail.id);
    },
  },
};
</script>
